import React from "react";
import axios from "axios";
import qs from 'qs';
import {show_loader} from "./functions";
import {OrganizationData} from "../interface";
declare var organization_data:OrganizationData;

export class OrgInfo extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
        this.state = {
            org_name: '-',
            org_num_managers: '-',
            org_num_members: '-',
            org_create_date: '-',
        }
    }

    componentDidMount() {
        this.getOrganizationInfo();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if( prevProps.currOrganization !== this.props.currOrganization ) {
            this.getOrganizationInfo();
        }
    }

    getOrganizationInfo() {
        if( this.props.currOrganization === 0 ) return;
        show_loader(true);

        axios.post( organization_data.admin_ajax, qs.stringify({
            action: 'fr_org_requests',
            req_nonce: organization_data.req_nonce,
            org_id: this.props.currOrganization,
        }) ).then( response=> {
            if( response ) {
                if( response.data && response.data.success ) {
                    const data = response.data.org_data;
                    this.setState({
                        org_name: data.org_name,
                        org_num_managers: data.org_num_managers,
                        org_num_members: data.org_num_members,
                        org_create_date: data.org_create_date
                    });
                }
            }
        } ).catch( error=>{
            console.error( 'Error', error );
        } ).finally(() => {
            show_loader(false);
        });
    }

    render() {
        return (
            <div className="organization_sub_account">
                <div className="org_info_row">
                    <div className="org_label">Organization Name:</div>
                    <div className="org_value">{this.state.org_name}</div>
                </div>
                <div className="org_info_row">
                    <div className="org_label">Number of Managers:</div>
                    <div className="org_value">{this.state.org_num_managers}</div>
                </div>
                <div className="org_info_row">
                    <div className="org_label">Number of Members:</div>
                    <div className="org_value">{this.state.org_num_members}</div>
                </div>
                <div className="org_info_row">
                    <div className="org_label">Organization Date:</div>
                    <div className="org_value">{this.state.org_create_date}</div>
                </div>
            </div>
        )
    }
}